import { Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/content.routes';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/services/auth.guard';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
    },
    {
        path: 'auth/login',
        component: LoginComponent,
      },
    {
        path: '',
        component: ContentComponent,
        children: content,
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        component: NotFoundComponent
      }

];